import { render, staticRenderFns } from "./CouponDetailModal.vue?vue&type=template&id=70b7a42d&scoped=true"
import script from "./CouponDetailModal.vue?vue&type=script&lang=js"
export * from "./CouponDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CouponDetailModal.vue?vue&type=style&index=0&id=70b7a42d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7a42d",
  null
  
)

export default component.exports